import React, {Component} from 'react'
import FeeEditForm from "./editform.component.jsx"
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import {FormattedMessage} from 'react-intl'
import SideBar from '../../common/layout/sidebar.component.jsx'

class FeeEdit extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            fee: {},
            feeName: '',
            editForm: ''
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')
        const feeId = this.props.match.params.feeId
        AppContext.getApiClient().get('/fees/' + feeId).then(fee => {
            this.setState({
                feeName: fee.attributes.name,
                editForm: <FeeEditForm fee={fee} />,
            })
        })
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-12 ui-title-bar">
                        <div className="row">
                            <div className="col-12">
                                <h2>
                                    <FormattedMessage
                                        id="fee.form.edit.title"
                                        defaultMessage="Edit: {feeName}"
                                        values={{feeName: this.state.feeName}}
                                    />
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.editForm}

            </div>
        );
    }
}

export default FeeEdit


// WEBPACK FOOTER //
// ./src/settings/fees/edit.component.jsx